import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { useForm } from "react-hook-form";

export const OrderHistory: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { handleSubmit } = useForm();

  const onSubmit = async (data: any) => {
    console.log("onsubmit===>", data); // Perform any action with the submitted data here
  };

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <Grid
      container
      sx={{
        flexGrow: 1,
        backgroundColor: "#F3F6F9",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {/* Header with Order History and Close Icon */}
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ padding: 3 }}
      >
        <Typography variant="h6" sx={{ color: "#388E3C", fontWeight: "bold" }}>
          Order History
        </Typography>
        <IconButton>
          <WSIcons.CloseIcon
            sx={{ backgroundColor: "red", color: "white" }}
            onClick={() => handleClick("/guestsearch")}
          />
        </IconButton>
      </Grid>

      {/* Main Content */}
      <Grid
        container
        spacing={3}
        alignItems="center"
        justifyContent="space-between"
        sx={{ padding: 2 }}
      >
        <Grid item>
          <IconButton
            sx={{
              border: "1px solid #ccc",
              padding: "8px",
              marginRight: "8px",
              borderRadius: "2px",
            }}
          >
            <WSIcons.KeyboardArrowUpIcon fontSize="large" />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography variant="h6">Order's</Typography>
        </Grid>
        <Grid item>
          <IconButton
            sx={{
              border: "1px solid #ccc",
              padding: "8px",
              marginRight: "8px",
              borderRadius: "2px",
            }}
          >
            <WSIcons.KeyboardArrowDownIcon fontSize="large" />
          </IconButton>
          <IconButton
            sx={{
              border: "1px solid #ccc",
              padding: "8px",
              marginRight: "8px",
              borderRadius: "2px",
            }}
          >
            <WSIcons.KeyboardArrowUpIcon fontSize="large" />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography variant="h6">ReceiptNo</Typography>
        </Grid>
        <Grid item>
          <IconButton
            sx={{
              border: "1px solid #ccc",
              padding: "8px",
              marginRight: "8px",
              borderRadius: "2px",
            }}
          >
            <WSIcons.KeyboardArrowDownIcon fontSize="large" />
          </IconButton>
        </Grid>
      </Grid>

      {/* Total and Amount Section */}
      <Grid
        container
        sx={{
          marginTop: "auto",
          paddingRight: 3,
          paddingBottom: 2,
          justifyContent: "flex-end",
        }}
      >
        <Typography variant="h6" sx={{ color: "#000", marginRight: 1 }}>
          Total:
        </Typography>
        <Typography variant="h6" sx={{ color: "#000", fontWeight: "bold" }}>
          0.00
        </Typography>
      </Grid>

      {/* Footer */}
      <Grid
        container
        sx={{
          backgroundColor: "#333",
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
          onClick={handleSubmit(onSubmit)}
        >
          ReOrder
        </Button>
      </Grid>
    </Grid>
  );
});
